const axios = require('axios');
const utils = require('../services/utilities.es6');

const ENV = process.env;

export default class analyticsService {
  static returnMapping() {
    return {
      'pro': {
        twitter: 'l6kkh',
        facebook: 'Lead',
      },
      'persecond': {
        twitter: 'l6kkm',
        facebook: 'Lead',
      },
      'user-registration': {
        twitter: 'l6ntv',
        facebook: 'CompleteRegistration',
      },
    };
  }

  static fbEvent(product) {
    const event = mapping[product].facebook;
    const cd = {};
    cd.value = '0.00';
    cd.currency = 'CAD';
    window.fbq.push(['track', event]);
  }

  static twitterEvent(product) {
    const id = mapping[product].twitter;
    window.twttr.conversion.trackPid(id, {
      tw_sale_amount: 0,
      tw_order_quantity: 0,
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/googleAnalytics.es6.js